import { MerchantStatus } from '../../data/static/data'

const mGetMerchantStatus: any = {
  A: MerchantStatus.Active,
  I: MerchantStatus.Inactive,
  B: MerchantStatus.Blocked,
  S: MerchantStatus.Suspend,
  H: MerchantStatus.HotMerchant,
  U: MerchantStatus.ClosedByMerchant,
  O: MerchantStatus.ClosedByOps,
}

export const getMerchantStatus = (status: string): MerchantStatus => {
  return mGetMerchantStatus[status] || MerchantStatus.Inactive
}

const gstCodeNStateNames: any = {
  '01': 'JAMMU AND KASHMIR',
  '02': 'HIMACHAL PRADESH',
  '03': 'PUNJAB',
  '04': 'CHANDIGARH',
  '05': 'UTTARAKHAND',
  '06': 'HARYANA',
  '07': 'DELHI',
  '08': 'RAJASTHAN',
  '09': 'UTTAR PRADESH',
  '10': 'BIHAR',
  '11': 'SIKKIM',
  '12': 'ARUNACHAL PRADESH',
  '13': 'NAGALAND',
  '14': 'MANIPUR',
  '15': 'MIZORAM',
  '16': 'TRIPURA',
  '17': 'MEGHALAYA',
  '18': 'ASSAM',
  '19': 'WEST BENGAL',
  '20': 'JHARKHAND',
  '21': 'ODISHA',
  '22': 'CHATTISGARH',
  '23': 'MADHYA PRADESH',
  '24': 'GUJARAT',
  '25': 'DAMAN AND DIU',
  '26': 'DADRA AND NAGAR HAVELI',
  '27': 'MAHARASHTRA',
  '28': 'ANDHRA PRADESH (OLD)',
  '29': 'KARNATAKA',
  '30': 'GOA',
  '31': 'LAKSHWADEEP',
  '32': 'KERALA',
  '33': 'TAMIL NADU',
  '34': 'PUDUCHERRY',
  '35': 'ANDAMAN AND NICOBAR ISLANDS',
  '36': 'TELANGANA',
  '37': 'ANDHRA PRADESH (NEW)',
}
export const getStateFromGST = (stateCode: string): string => {
  return gstCodeNStateNames[stateCode] || ''
}

const banksParser = (response: any, isPopular: boolean) => {
  const retData = response.map((item: any) => ({
    id: item?.bankCode,
    name: item?.bankName,
    rank: item?.rank,
    isPopular: isPopular,
    logo: item?.logo ? item.logo : '',
    bankCode: item?.bankCode,
    ifscCode: item?.ifsc,
    iin: item?.iin,
    accountName: item?.accountName,
  }))
  return retData
}

const parseLinkedBanks = (response: any, bank: any) => {
  const data = response?.data?.response?.acctList ?? []
  const retData = data?.map((item: any) => ({
    id: bank.id,
    name: bank.name,
    rank: bank.rank,
    isPopular: bank.isPopular,
    logo: bank.logo,
    ifsc: item?.ifsc ?? '',
    addressLine: item?.addressLine ?? '',
    accountNumber: item?.plainAccountNumber ?? '',
    accountName: item?.accountName,
  }))
  return retData
}

export { banksParser, parseLinkedBanks }
